import React from 'react';

const BadgeCounter = ({badgeNumber, variant = 'default'}) => (
    (badgeNumber !== parseInt(badgeNumber, 10) || badgeNumber < 1 ) ? null : <span className={`badge badge-${variant}`}>{badgeNumber}</span>
)

export default BadgeCounter;